"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const colors_1 = __importDefault(require("../../styles/colors"));
const styles_1 = __importDefault(require("../../styles/styles"));
const text_1 = __importStar(require("../text/text"));
const textStyles_1 = __importDefault(require("../text/textStyles"));
const summaryRow_1 = __importDefault(require("./summaryRow"));
const SummaryBox = ({ title, data }) => {
    return (react_1.default.createElement(react_native_1.View, null,
        react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE, biggerSubtitle: true, style: textStyles_1.default.bold }, title),
        react_1.default.createElement(react_native_1.View, { style: [
                { borderWidth: 1, borderRadius: 8, borderColor: colors_1.default.COLOR_GRAY_7 },
                styles_1.default.mainContainerPadding,
                styles_1.default.minimumMarginBetweenElementsVertically,
            ] }, data.map((row, index) => {
            let summaryText = '';
            if (row.min_value) {
                summaryText = summaryText.concat(`starting from ${row.min_value} `);
            }
            if (row.max_value) {
                summaryText = summaryText.concat(`up to ${row.max_value}`);
            }
            return (react_1.default.createElement(react_native_1.View, { style: index !== data.length - 1
                    ? { borderBottomWidth: 1, borderBottomColor: colors_1.default.COLOR_GRAY_7 }
                    : [] },
                react_1.default.createElement(summaryRow_1.default, { label: row.field, value: row.value ? row.value : '', fieldName: row.fieldName, extraText: summaryText.charAt(0).toUpperCase() + summaryText.slice(1) })));
        }))));
};
exports.default = SummaryBox;
